// Centralized shortcut key constants for navigation
// Update this file to add or change navigation shortcut keys

export const FLEET_KEY = "f";
export const ORDERS_KEY = "o";
export const CREATE_KEY = "n";
export const CUSTOMER_KEY = "c";
export const QUOTES_KEY = "q";
export const SCHEDULES_KEY = "s";
export const PACKAGES_KEY = "p";
